import { Injectable, NgZone } from '@angular/core';
import { UserService } from './user.service';
import { LoginService } from './login.service';
import { User } from '../models/user';
import _ from 'lodash';
import { SocketService } from './socket.service';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {

  currentUser: User = new User();
  SettingsService = {};
  settings = this.currentUser.settings || {};
  syncListeners = [];

  constructor(private userService: UserService,
    private loginService: LoginService,
    private ngZone: NgZone,
    private socketService: SocketService) {
    this.loginService.currentUser.subscribe(x => this.currentUser = x);
  }

  createListener(object: any, options: any, monitor: any) {
    const source = options.source || options.target;
    return () => {
      const value = object[options.target] = (source in this.settings) ?
        this.settings[source] :
        options.defaultValue;

      if (monitor) {
        monitor(value);
      }
    };
  }

  applyDelta(delta: any) {
    this.ngZone.run(() => {
      _.merge(this.settings, delta, (a: any, b: any) => {
        // New Arrays overwrite old Arrays
        if (_.isArray(b)) {
          return b;
        }
      });

      for (let i = 0, l = this.syncListeners.length; i < l; ++i) {
        this.syncListeners[i]();
      }
    });
  }

  update(delta) {
    // this.socketService.emit('user.settings.update', delta);
    this.applyDelta(delta);
  }

  get(key) {
    return this.settings[key];
  }

  set(key, value) {
    let delta = Object.create(null);
    delta[key] = value;
    this.update(delta);
  }

  reset() {
    // this.socketService.emit('user.settings.reset');
    this.settings = {};
    this.applyDelta(null);
  }

  bind(scope, options) {
    const value = (possibleValue, defaultValue) => {
      return (typeof possibleValue !== 'undefined') ? possibleValue : defaultValue
    }

    let source = options.source || options.target
    let defaultValue = value(options.defaultValue, scope[options.target])

    // Need to check   <---------------
    // scope.$watch(
    //   options.target
    // , function(newValue, oldValue) {
    //     // Skip initial value.
    //     if (newValue !== oldValue) {
    //       let delta = Object.create(null)
    //       //delta[source] = angular.copy(newValue)
    //       //delta[source] = _(newValue);
    //       delta[source] = Object.assign({}, newValue)
    //       this.update(delta)
    //     }
    //   }
    // , true
    // )

    // scope.$watch(
    //   function() {
    //     return this.settings[source]
    //   }
    // , function(newValue, oldValue) {
    //     // Skip initial value. The new value might not be different if
    //     // settings were reset, for example. In that case we fall back
    //     // to the default value.
    //     if (newValue !== oldValue) {
    //       scope[options.target] = value(newValue, defaultValue)
    //     }
    //   }
    // , true
    // )

    scope[options.target] = value(this.settings[source], defaultValue)
  }

  sync(object, options, monitor) {
    let listener = this.createListener(object, options, monitor)
    listener() // Initialize
    return this.syncListeners.push(listener) - 1
  }

  unsync(id) {
    this.syncListeners.splice(id, 1)
  }

  // this.socketService.on('user.settings.update', this.applyDelta);

}
